
const initailState = {
    war_room:null,
    nextKey:''
}
const WarRoom=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_WAR_ROOM_DATA':
            return{ 
                war_room: action.payload,
            }
        default:
            return state;
    }
}

export default WarRoom